import { useNavigate } from 'react-router-dom';

const AuthError = () => {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate('/login'); // Redirect to your login page
  };

  const handleContactSupport = () => {
    window.location.href = 'mailto:support@yourcompany.com';
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>⚠️</div>
        <h1 style={styles.title}>We couldn't sign you in</h1>
        <p style={styles.message}>
          Something went wrong during the login process. This might be a temporary issue.
        </p>
        
        <div style={styles.actions}>
          <button 
            onClick={handleTryAgain}
            style={styles.primaryButton}
          >
            Try Again
          </button>
          
        </div>
        
        <p style={styles.tip}>
          Tip: Make sure you're using the correct email and password, and that your internet connection is stable.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    padding: '20px',
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    padding: '40px',
    maxWidth: '500px',
    textAlign: 'center',
  },
  icon: {
    fontSize: '48px',
    marginBottom: '20px',
  },
  title: {
    color: '#2d3748',
    marginBottom: '16px',
    fontSize: '24px',
  },
  message: {
    color: '#4a5568',
    fontSize: '16px',
    lineHeight: '1.5',
    marginBottom: '24px',
  },
  actions: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    marginBottom: '24px',
  },
  primaryButton: {
    backgroundColor: '#3182ce',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '12px 24px',
    fontSize: '16px',
    cursor: 'pointer',
    fontWeight: '500',
  },
  secondaryButton: {
    backgroundColor: 'transparent',
    color: '#3182ce',
    border: '1px solid #3182ce',
    borderRadius: '4px',
    padding: '12px 24px',
    fontSize: '16px',
    cursor: 'pointer',
    fontWeight: '500',
  },
  tip: {
    color: '#718096',
    fontSize: '14px',
    fontStyle: 'italic',
    marginTop: '16px',
  }
};

export default AuthError;